import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Container, Grid, Header, Icon, List, Segment } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { getTranslate } from "react-localize-redux";
import { getActivities } from "../../reducer";
import { loadActivities } from "../../reducer/actions";


class Activities extends Component
{

    componentDidMount() {
        this.props.loadActivities();
    }

    getActivityList(){
        return(
                <List divided relaxed>
                    <List.Item key='addActivity'>
                      <List.Content floated='right'>
                        <Button as={Link} to={'/admin/activities/create'}>{this.props.translate('general.add')}</Button>
                      </List.Content>
                      <List.Icon size='large' name='lightning' verticalAlign='middle'/>
                      <List.Content>
                        <List.Header>{this.props.translate('admin.activity.addNew')}</List.Header>
                      </List.Content>
                    </List.Item>
                    {this.props.activities && typeof this.props.activities !== 'undefined' && this.props.activities.map((activity)=>(
                        <List.Item key={activity.id}  as={Link} to={'/admin/activities/'+activity.id}>
                            <List.Icon name='lightning' size='large' verticalAlign='middle' />
                            <List.Content>
                                <List.Header>{activity.displayName}</List.Header>
                            </List.Content>
                        </List.Item>
                    ))}
                </List>
        );
    }

    render(){
        return(
            <Container text style={{padding: '1em 1em'}}>
                <Header as='h2' icon textAlign='center'>
                  <Icon name='lightning' circular />
                </Header>
                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column width={14}>

                        <div>
                            <Header as='h2' color='teal' textAlign='center'>
                                {this.props.translate('admin.activity.label')}
                            </Header>
                            <Segment stacked>
                                {this.getActivityList()}
                            </Segment>
                        </div>
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }

}



const mapStateToProps = state => {
    return {
        activities: getActivities(state.admin),
        translate: getTranslate(state.localize),
    }
};

const mapDispatchToProps = (dispatch) => {
    return ({
        loadActivities: () => {
            dispatch(loadActivities())
        }
    });
};


function mergeProps(stateProps, dispatchProps, ownProps) {
    return {

        ...stateProps,
        ...ownProps,
        ...dispatchProps,

    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Activities)



// WEBPACK FOOTER //
// ./src/scenes/Admin/scenes/Activities/index.js